module.exports = __webpack_public_path__ + "img/fly zipper length.65c5bc81.png";